import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue } from "firebase/database";

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    onValue(settingsRef, settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;

     let { bf, df, tf, mf, driverfareTotal, airportFees, driverfareGST, platformFee, platformFeeGST, subtotalexGST, totalGST, grandTotal } = FareCalculator(bookingData.drop.description, bookingData.pickup.description, distance, res.time_in_secs, bookingData.carDetails, bookingData.instructionData, settings.decimal);
//         console.log('baseCalculated: ', driverfareTotal);

      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          pickup:bookingData.pickup,
          drop:bookingData.drop,
          carDetails:bookingData.carDetails,
          instructionData: bookingData.instructionData,
          estimateDistance: parseFloat(distance).toFixed(settings.decimal),
          fareCost: driverfareTotal ? parseFloat(driverfareTotal).toFixed(settings.decimal) : 0,
          estimateFare: grandTotal ? parseFloat(grandTotal).toFixed(settings.decimal) : 0,
          estimateTime:res.time_in_secs,
          convenience_fees: platformFee ? parseFloat(platformFee).toFixed(settings.decimal) : 0,
          waypoints: waypoints,

          bf: bf ? parseFloat(bf).toFixed(settings.decimal) : 0,
          df: df ? parseFloat(df).toFixed(settings.decimal) : 0,
          tf: tf ? parseFloat(tf).toFixed(settings.decimal) : 0,
          mf: mf ? parseFloat(mf).toFixed(settings.decimal) : 0,
          driverfareTotal: driverfareTotal ? parseFloat(driverfareTotal).toFixed(settings.decimal) : 0,
          airportFees: airportFees ? parseFloat(airportFees).toFixed(settings.decimal) : 0,
          driverfareGST: driverfareGST ? parseFloat(driverfareGST).toFixed(settings.decimal) : 0,
          platformFee: platformFee ? parseFloat(platformFee).toFixed(settings.decimal) : 0,
          platformFeeGST: platformFeeGST ? parseFloat(platformFeeGST).toFixed(settings.decimal) : 0,
          subtotalexGST: subtotalexGST ? parseFloat(subtotalexGST).toFixed(settings.decimal) : 0,
          totalGST: totalGST ? parseFloat(totalGST).toFixed(settings.decimal) : 0,
          grandTotal: grandTotal ? parseFloat(grandTotal).toFixed(settings.decimal) : 0

        },
      });
    }, {onlyOnce:true});
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
